import Mileniala1 from "./milenial (1).webp";
import Mileniala2 from "./milenial (2).webp";
import Mileniala3 from "./milenial (3).webp";
import Mileniala4 from "./milenial (4).webp";
import Mileniala5 from "./milenial (5).webp";
import Mileniala6 from "./milenial (6).webp";
import Mileniala7 from "./milenial (7).webp";

const mileniala = [
  Mileniala1,
  Mileniala2,
  Mileniala3,
  Mileniala4,
  Mileniala5,
  Mileniala6,
  Mileniala7,
];

export default mileniala;
